import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getUserRolePermissionByLoggedInUserAPI } from '../../Store/Action/userRolePermissionAction';

const UserRolePermissionContext = createContext();

export const UserRolePermissionProvider = ({ children }) => {
  const [userRolePermission, setUserRolePermission] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserRolePermission = async () => {
      try {
        await dispatch(getUserRolePermissionByLoggedInUserAPI({}, result => {
          if (result && Array.isArray(result)) {
            const mergedPermissions = result
              .filter(item => item && item?.permission_name) 
              .map(item => item?.permission_name);
            setUserRolePermission(mergedPermissions);
          } else {
            console.log('Unexpected result format or empty result:', result);
          }
        }));
      } catch (error) {
        console.log('Error fetching user role permissions:', error);
      }
    };

    fetchUserRolePermission();
  }, [dispatch]); // Empty dependency array to run effect only once

  return (
    <UserRolePermissionContext.Provider value={userRolePermission}>
      {children}
    </UserRolePermissionContext.Provider>
  );
};

export const useUserRolePermission = () => {
  return useContext(UserRolePermissionContext);
};
